import {createSelector} from 'reselect';

export const getPudo = state => state.pudo;
export const getPudoSavedAddresses = state => state.pudo.savedAddresses;
export const getPudoSavedAddressesLength = state => state.pudo.initialAddressLength;

export const getPudoCollectionPointAddress = createSelector(
  [getPudo],
  pudo => (pudo.collectionPoints[pudo.displayCollectionPoint]),
);

export const getIndexOfPudoAddressToShowInCollectorName = createSelector(
  [getPudo],
  pudo => pudo.indexOfAddressToShowInCollectorName,
);

export const hasSavedPudoAddresses = createSelector(
  [getPudoSavedAddresses],
  pudoSavedAddresses => pudoSavedAddresses.length > 0,
);

export const getSelectedPudoAddress = createSelector(
  [getPudo],
  pudo => pudo.savedAddresses[pudo.selectedCollectionPoint],
);

export const isSelectedNewPudoAddress = createSelector(
  [getPudo, getPudoSavedAddressesLength],
  (pudo, savedAddressLength) => pudo.selectedCollectionPoint + 1 > savedAddressLength,
);

export const getPudoDeliveryData = createSelector(
  [getSelectedPudoAddress],
  (selectedAddress) => {
    if (!selectedAddress) return;
    
    return {
      country: selectedAddress.countryCode,
      state: selectedAddress.line4,
      postCode: selectedAddress.postcode,
      courierId: selectedAddress.courierId,
      clickAndCollectLocationId: selectedAddress.locationId,
      type: selectedAddress.type,
      serviceId: selectedAddress.serviceId,
      townCity: selectedAddress.line3,
    };
  },
);

export const getPudoDeliveryAddressDetails = createSelector(
  [getSelectedPudoAddress],
  (selectedPudoAddress) => {
    if (!selectedPudoAddress) return;
    
    return {
      addressType: 'click-and-collect',
      addressee: selectedPudoAddress.name,
      organisationName: selectedPudoAddress.organisationName,
      buildingNameNumber: selectedPudoAddress.buildingNameNumber,
      line1: selectedPudoAddress.line1,
      line2: selectedPudoAddress.line2,
      line3: selectedPudoAddress.line3,
      line4: selectedPudoAddress.line4,
      postcode: selectedPudoAddress.postcode,
      countryCode: selectedPudoAddress.countryCode,
      courierId: selectedPudoAddress.courierId,
      locationId: selectedPudoAddress.locationId,
    };
  },
);
